export default __webpack_public_path__ + "717a5580cc7f021a827987a1da9ddb4e.svg";